<template>
  <div id="app">
    <commonHeader v-if="$route.meta.requiresAuth == true && isShowCommerHeader" />
    <router-view></router-view>
  </div>
</template>

<script>
import commonHeader from '@components/headers/Default.vue'
import user from '@api/login'

export default {
  name: 'app',
  components: {
    commonHeader
  },
  computed: {
    isShowCommerHeader() {
      return this.$store.state.book.isShowCommerHeader && !this.$store.state.common.isStaticBook
    }
  },
  created() {
    // 保存刷新前的书刊专辑状态
    if (sessionStorage.getItem('userMsg')) {
      let manage = { manage: JSON.parse(sessionStorage.getItem('userMsg')) }
      this.$store.replaceState(Object.assign({}, this.$store.state, manage))
    }
    window.addEventListener('pagehide', () => {
      sessionStorage.setItem('userMsg', JSON.stringify(this.$store.state.manage))
    })

    if (process.env.VUE_APP_PROJECT_NAME === 'static') {
      this.$store.commit('common/UPDATE_BOOK_STATUS', true)
    }
    // 全局捕获未处理的rejection
    window.addEventListener('unhandledrejection', function(event) {
      console.log('unhandledrejection', event.reason)
      event.preventDefault()
    })

    /*旗帜app校验*/
    const accessCode = this.$route.query.accessCode
    if (accessCode && accessCode !== '') {
      user.getQizhiUserInfo(accessCode).then((res) => {
        if (res.data.status === 0 && res.data.data) {
          localStorage.setItem('qizhiNickname', res.data.data.nickname)
          localStorage.setItem('qizhiPhone', res.data.data.phone)
          localStorage.setItem('accessCode', accessCode)
        }
      })
    }
  }
}
</script>

<style lang="scss">
body {
  /*min-width: 1000px;*/
  overflow: hidden;
}
#app {
  margin: 0 auto;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, 'Hiragino Sans GB', '微软雅黑', SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* background-color: #fff; */
}
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
.flex {
  display: flex;
}
.flex-between {
  justify-content: space-between;
}
</style>
